import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import * as React from 'react';
import styled from 'styled-components';

import { getInitialQuestionListData } from '../../sample.utils';
import { RendererWithPlugins } from '@doltech/ui/lib/slatePlugins/components/core/readonly/RendererWithPlugins';
import { QuestionListPlugin } from '@doltech/ui/lib/shared/components/IELTSample/QuestionList/plugins/QuestionListPlugin';

const Main = styled.div`
  font-size: 20px;
  font-weight: 600px;
  background-color: ${colorsV2.white100};
  border: 1px solid ${colorsV2.black20};
  padding: 16px;
  display: grid;
  gap: 12px;
  border-radius: 16px;

  @media ${deviceBreakpoints.fromTablet} {
    padding: 24px;
  }
`;

const plugins = [QuestionListPlugin({ isReadOnly: true })];

export const QuestionListPreview = ({ detailData }) => {
  const questionParagraph = React.useMemo(() => {
    return getInitialQuestionListData(detailData);
  }, [detailData]);

  return (
    <Main>
      <RendererWithPlugins value={questionParagraph.content} plugins={plugins} />
    </Main>
  );
};
